<template>
    <loading v-if="loadingTab" :size="2" message="Загружаем настройки уведомлений..."></loading>
    <div v-else>
        <table class="table table-responsive" v-if="settingsActions.length > 0">
            <thead>
            <tr>
                <th>Событие</th>
                <th v-for="channel in settingsChannels">{{channel.name}}</th>
            </tr>
            </thead>
            <tbody v-if="settingsActions">
            <tr v-for="action in settingsActions">
                <td>{{action.name}}</td>
                <td v-for="setting in getSettingsByAction(action)">
                    <label class="switch switch-lg switch-3d switch-primary">
                        <input v-model="setting.value" @change="changeSetting(setting)" :disabled="loading" type="checkbox" class="switch-input">
                        <span class="switch-label"></span>
                        <span class="switch-handle"></span>
                        <small v-if="setting.value">включено</small>
                        <small v-else>выключено</small>
                    </label>
                </td>
            </tr>
            </tbody>
        </table>
        <loading v-if="loading" :size="2" message="Обновляем настройки..."></loading>
    </div>
</template>

<script>
  import getUserNotificationSettings from './../../gql/queries/getUserNotificationSettings.graphql'
  import updateUserNotificationSetting from './../../gql/mutations/UpdateUserNotificationSetting.graphql'
  import indexOfProperty from './../../helpers/indexOfProperty'
  import { mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    props: ['userId'],
    computed: {
      settingsActions () {
        return this.settings.map(function (item) {
          return {id: item.action.id, name: item.action.name}
        }).filter(function (value, index, self) {
          return indexOfProperty(self, 'id', value.id) === index
        })
      },
      settingsChannels () {
        return this.settings.map(function (item) {
          return {id: item.channel.id, name: item.channel.name}
        }).filter(function (value, index, self) {
          return indexOfProperty(self, 'id', value.id) === index
        })
      }
    },
    data () {
      return {
        settings: [],
        loading: false,
        loadingTab: false
      }
    },
    methods: {
      getSettingsByAction (action) {
        return this.settings.filter(function (setting) {
          return setting.action.id === action.id
        })
      },
      changeSetting (setting) {
        this.loading = true
        this.$apollo.mutate({
          mutation: updateUserNotificationSetting,
          variables: {
            userId: this.userId,
            channel: setting.channel.id,
            action: setting.action.id,
            value: setting.value
          }
        }).then(() => {
          this.loading = false
          this.addToast({
            text: 'Настройки успешно обновлены',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          setting.value = !setting.value
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка при сохраннеии настроек: ' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      settingsData: {
        query: getUserNotificationSettings,
        variables () {
          return {
            userId: this.userId
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading) {
          this.loadingTab = isLoading
        },
        update: (data) => {
          return data.userNotificationsSetting
        },
        result ({ data, loader, networkStatus }) {
          this.settings = JSON.parse(JSON.stringify(data.userNotificationsSetting))
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProfileNotificationSettings.vue?3f36754b